import { render, staticRenderFns } from "./policyRegulations.vue?vue&type=template&id=409025b4&scoped=true&"
import script from "./policyRegulations.vue?vue&type=script&lang=js&"
export * from "./policyRegulations.vue?vue&type=script&lang=js&"
import style0 from "./policyRegulations.vue?vue&type=style&index=0&id=409025b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409025b4",
  null
  
)

export default component.exports